define.alias("shared/components/shared/ui/checkbox-switch", "preview-grid/components/shared/ui/checkbox-switch");